// Amadeus GDS-code amenity dictionary. Each entry maps a 3-letter or
// numeric Amadeus amenity code (CML, OEA, 0CH, …) to a localized label,
// icon, and optional tooltip. Consumed by the shared get_amenity_info
// resolver in @liveflight/resources/amenities.

export const AMADEUS_AMENITIES = {
  "06R": {
    txt: "Accumulo miglia",
    icon: "check_circle",
    tooltip: "",
  },
  "09D": {
    txt: "Accumulo miglia",
    icon: "check_circle",
    tooltip: "",
  },
  "0AV": {
    txt: "Alcolici a bordo",
    icon: "check_circle",
    tooltip: "",
  },
  "0AX": {
    txt: "Bevande",
    icon: "check_circle",
    tooltip: "",
  },
  "09P": {
    txt: "Bagaglio in cabina",
    icon: "trolley",
    tooltip: "",
  },
  "0MR": {
    txt: "Bagaglio cabina 1 pezzo da 12 kg",
    icon: "trolley",
    tooltip: "",
  },
  "0MS": {
    txt: "Bagaglio in cabina da 18 kg 2 pezzi",
    icon: "trolley",
    tooltip: "",
  },
  "010": {
    txt: "Bagaglio a mano",
    icon: "trolley",
    tooltip: "",
  },
  "0L5": {
    txt: "Bagaglio a mano piccolo 40x20x25",
    icon: "backpack",
    tooltip: "",
  },
  "0MU": {
    txt: "Bagaglio a mano 115 cm",
    icon: "trolley",
    tooltip: "",
  },
  "0M3": {
    txt: "Bagaglio a mano: max 7 kg, 45 L, dimensioni totali max 115 cm",
    icon: "trolley",
    tooltip: "",
  },
  "06I": {
    txt: "Cambi prima della partenza",
    icon: "check_circle",
    tooltip: "",
  },
  "059": {
    txt: "Biglietto modificabile",
    icon: "check_circle",
    tooltip: "",
  },
  "0FA": {
    txt: "Bagagli stiva 1 da 23 kg",
    icon: "luggage",
    tooltip: "",
  },
  "0CC": {
    txt: "Primo bagaglio stiva",
    icon: "luggage",
    tooltip: "",
  },
  "0CD": {
    txt: "Secondo bagaglio stiva",
    icon: "luggage",
    tooltip: "",
  },
  "0CH": {
    txt: "Bagaglio in stiva",
    icon: "luggage",
    tooltip: "",
  },
  "0GO": {
    txt: "Bagaglio stiva 23 kg dimensioni 158 totali",
    icon: "luggage",
    tooltip: "",
  },
  "050": {
    txt: "Posto standard",
    icon: "check_circle",
    tooltip: "",
  },
  CML: {
    txt: "Pasto gratuito",
    icon: "check_circle",
    tooltip: "",
  },
  "0B1": {
    txt: "Intrattenimento a bordo",
    icon: "check_circle",
    tooltip: "",
  },
  BG1: {
    txt: "Primo bagaglio da stiva 23 kg",
    icon: "luggage",
    tooltip: "",
  },
  "06D": {
    txt: "Accumulo miglia",
    icon: "check_circle",
    tooltip: "",
  },
  OEA: {
    txt: "Intrattenimento a bordo",
    icon: "check_circle",
    tooltip: "",
  },
  "0CL": {
    txt: "Accesso internet",
    icon: "check_circle",
    tooltip: "",
  },
  "04H": {
    txt: "Accesso internet",
    icon: "check_circle",
    tooltip: "",
  },
  "0BX": {
    txt: "Accesso lounge",
    icon: "check_circle",
    tooltip: "",
  },
  "0B3": {
    txt: "Cibo e bevande",
    icon: "check_circle",
    tooltip: "",
  },
  "057": {
    txt: "Accumulo miglia",
    icon: "check_circle",
    tooltip: "",
  },
  "0CM": {
    txt: "Accumulo miglia",
    icon: "check_circle",
    tooltip: "",
  },
  "04D": {
    txt: "Upgrade a pagamento",
    icon: "check_circle",
    tooltip: "",
  },
  "04J": {
    txt: "Oggetti personali",
    icon: "check_circle",
    tooltip:
      "una piccola borsetta, una piccola borsa per laptop o un piccolo zaino",
  },
  PSL: {
    txt: "Oggetti personali",
    icon: "check_circle",
    tooltip:
      "una piccola borsetta, una piccola borsa per laptop o un piccolo zaino",
  },
  "0B5": {
    txt: "Preassegnazione posti",
    icon: "check_circle",
    tooltip: "",
  },
  PQC: {
    txt: "Premi a credito",
    icon: "check_circle",
    tooltip: "",
  },
  "05Z": {
    txt: "Posto a sedere con spazio gambe e posto su uscita emergenza",
    icon: "check_circle",
    tooltip: "",
  },
  "0G6": {
    txt: "Imbarco prioritario",
    icon: "check_circle",
    tooltip: "",
  },
  "03P": {
    txt: "Priorità check in",
    icon: "check_circle",
    tooltip: "",
  },
  "0LW": {
    txt: "Controlli sicurezza snelli e priorità",
    icon: "check_circle",
    tooltip: "",
  },
  "056": {
    txt: "Biglietto rimborsabile",
    icon: "check_circle",
    tooltip: "",
  },
  SDC: {
    txt: "Cambio lo stesso giorno",
    icon: "check_circle",
    tooltip: "",
  },
  PSA: {
    txt: "Posti preassegnati",
    icon: "check_circle",
    tooltip: "",
  },
  BG2: {
    txt: "Secondo bagaglio in stiva 23 kg",
    icon: "luggage",
    tooltip: "",
  },
  "07G": {
    txt: "Sky Priority",
    icon: "check_circle",
    tooltip: "",
  },
  "0AT": {
    txt: "Snack",
    icon: "check_circle",
    tooltip: "",
  },
  STS: {
    txt: "Posti standard",
    icon: "check_circle",
    tooltip: "",
  },
  "0BH": {
    txt: "Minori non accompagnati",
    icon: "check_circle",
    tooltip: "",
  },
  "058": {
    txt: "Possibilità upgrade",
    icon: "check_circle",
    tooltip: "",
  },
  "0MM": {
    txt: "Oggetti personali",
    icon: "check_circle",
    tooltip: "",
  },
  "0MQ": {
    txt: "Bagaglio a mano dimensioni 115 totali",
    icon: "trolley",
    tooltip: "",
  },
  "06J": {
    txt: "Cambi dopo la partenza",
    icon: "check_circle",
    tooltip: "",
  },
  "0IK": {
    txt: "Bagagli in eccesso",
    icon: "check_circle",
    tooltip: "",
  },
  "0C2": {
    txt: "Bagaglio stiva 20 kg",
    icon: "luggage",
    tooltip: "",
  },
  "0L7": {
    txt: "Cambio nome",
    icon: "check_circle",
    tooltip: "",
  },
  "0LF": {
    txt: "Bagaglio prioritario",
    icon: "check_circle",
    tooltip: "",
  },
  "0CZ": {
    txt: "Bagaglio cabina 10 kg",
    icon: "trolley",
    tooltip: "",
  },
  "0MJ": {
    txt: "Bagaglio cabina 10 kg",
    icon: "trolley",
    tooltip: "",
  },
  IB4: {
    txt: "Posto standard selezionabile 24 ore prima della partenza",
    icon: "check_circle",
    tooltip: "",
  },
  "077": {
    txt: "Bagaglio personale a bordo",
    icon: "check_circle",
    tooltip: "",
  },
  IB0: {
    txt: "Programma fedeltà",
    icon: "check_circle",
    tooltip: "",
  },
  IB1: {
    txt: "Programma fedeltà elite",
    icon: "check_circle",
    tooltip: "",
  },
  IB5: {
    txt: "Posto xl",
    icon: "check_circle",
    tooltip: "",
  },
  IB3: {
    txt: "Scelta posto anteriore",
    icon: "check_circle",
    tooltip: "",
  },
  IC3: {
    txt: "Snack e bevande",
    icon: "check_circle",
    tooltip: "",
  },
  "09A": {
    txt: "Wifi a bordo",
    icon: "check_circle",
    tooltip: "",
  },
  "068": {
    txt: "Modifica sempre",
    icon: "check_circle",
    tooltip: "",
  },
  "0CE": {
    txt: "Terzo bagaglio stiva",
    icon: "luggage",
    tooltip: "",
  },
  IB7: {
    txt: "Rimborsabile sempre",
    icon: "check_circle",
    tooltip: "",
  },
  "0C3": {
    txt: "Bagaglio stiva 1 pezzo da 23 kg",
    icon: "luggage",
    tooltip: "",
  },
  GSH: {
    txt: "Go show",
    icon: "check_circle",
    tooltip: "",
  },
  "09Q": {
    txt: "Bagaglio in cabina 8 kg",
    icon: "trolley",
    tooltip: "",
  },
  FBY: {
    txt: "Bagaglio in stiva 23 kg",
    icon: "luggage",
    tooltip: "",
  },
  "07H": {
    txt: "Cambio del volo il giorno della partenza per uno precedente",
    icon: "check_circle",
    tooltip: "",
  },
  PSG: {
    txt: "Controlli di sicurezza prioritari in Germania",
    icon: "check_circle",
    tooltip: "",
  },
  PSF: {
    txt: "Controlli di sicurezza prioritari in Brussels",
    icon: "check_circle",
    tooltip: "",
  },
  "018": {
    txt: "Catering a bordo",
    icon: "check_circle",
    tooltip: "",
  },
  PZS: {
    txt: "Posti con spazio per le gambe",
    icon: "check_circle",
    tooltip: "",
  },
  "06K": {
    txt: "Rimborso prima della partenza",
    icon: "check_circle",
    tooltip: "",
  },
  "06L": {
    txt: "Rimborso dopo la partenza",
    icon: "check_circle",
    tooltip: "",
  },
  SEA: {
    txt: "Posto a sedere vicino libero",
    icon: "check_circle",
    tooltip: "",
  },
  "0AA": {
    txt: "Bagaglio prepagato",
    icon: "check_circle",
    tooltip: "",
  },
  P01: {
    txt: "Bagaglio stiva gratuito",
    icon: "luggage",
    tooltip: "",
  },
  A25: {
    txt: "Bagaglio stiva gratuito 25 kg",
    icon: "luggage",
    tooltip: "",
  },
  "0D4": {
    txt: "Attrezzatura golf",
    icon: "check_circle",
    tooltip: "",
  },
  "05U": {
    txt: "Accumulo miglia",
    icon: "check_circle",
    tooltip: "",
  },
  "0NN": {
    txt: "Penali no show",
    icon: "check_circle",
    tooltip: "",
  },
  "0H6": {
    txt: "Costo peso in eccesso",
    icon: "check_circle",
    tooltip: "",
  },
  SA4: {
    txt: "Posto vicino libero",
    icon: "check_circle",
    tooltip: "",
  },
  "09C": {
    txt: "Accumulo miglia",
    icon: "check_circle",
    tooltip: "",
  },
  A30: {
    txt: "Bagaglio stiva 30 kg gratis",
    icon: "luggage",
    tooltip: "",
  },
  "06C": {
    txt: "Accumulo miglia",
    icon: "check_circle",
    tooltip: "",
  },
  BAG: {
    txt: "Bagaglio incluso",
    icon: "check_circle",
    tooltip: "",
  },
  "0AK": {
    txt: "Pasto",
    icon: "check_circle",
    tooltip: "",
  },
  CNR: {
    txt: "",
    icon: "check_circle",
    tooltip: "",
  },
  "0BN": {
    txt: "Autista",
    icon: "check_circle",
    tooltip: "",
  },
  "0KX": {
    txt: "Bagaglio mano 14 kg",
    icon: "trolley",
    tooltip: "",
  },
  "06H": {
    txt: "Accumulo miglia",
    icon: "check_circle",
    tooltip: "",
  },
  "029": {
    txt: "Imbarco veloce",
    icon: "check_circle",
    tooltip: "",
  },
  "0AW": {
    txt: "No alcolici",
    icon: "check_circle",
    tooltip: "",
  },
  "02Q": {
    txt: "USB a bordo",
    icon: "check_circle",
    tooltip: "",
  },
  "05T": {
    txt: "Accredito punti",
    icon: "check_circle",
    tooltip: "",
  },
  BRD: {
    txt: "Ultimo a salire a bordo",
    icon: "check_circle",
    tooltip: "",
  },
  BIN: {
    txt: "Spazio limitato cappelliera",
    icon: "check_circle",
    tooltip: "",
  },
  SBO: {
    txt: "Imbarco standard",
    icon: "check_circle",
    tooltip: "",
  },
  MDL: {
    txt: "Accumulo punti",
    icon: "check_circle",
    tooltip: "",
  },
  "0E8": {
    txt: "Bagaglio in stiva 23 kg 140 cm",
    icon: "luggage",
    tooltip: "",
  },
  "055": {
    txt: "Penale per cambio data",
    icon: "check_circle",
    tooltip: "",
  },
  "08S": {
    txt: "Cambio biglietto stesso giorno della partenza",
    icon: "check_circle",
    tooltip: "",
  },
  "0GP": {
    txt: "1 bagaglio max 23 kg cm 208",
    icon: "luggage",
    tooltip: "",
  },
  "0MO": {
    txt: "Bagaglio in cabina 23 kg cm 55x45x25",
    icon: "trolley",
    tooltip: "",
  },
  CB1: {
    txt: "Bagaglio sotto il sedile 88 cm",
    icon: "check_circle",
    tooltip: "",
  },
  FB1: {
    txt: "1 bagaglio da stiva 23 kg",
    icon: "luggage",
    tooltip: "",
  },
  CB2: {
    txt: "Bagaglio a mano fino a 10kg",
    icon: "trolley",
    tooltip: "",
  },
  FB2: {
    txt: "2 bagagli stiva 23kg",
    icon: "luggage",
    tooltip: "",
  },
  CB3: {
    txt: "Bagaglio in cabina 15 kg",
    icon: "trolley",
    tooltip: "",
  },
  "0C5": {
    txt: "Bagaglio stiva 30 kg",
    icon: "luggage",
    tooltip: "",
  },
  "0C7": {
    txt: "Bagaglio stiva 35 kg",
    icon: "luggage",
    tooltip: "",
  },
  "06P": {
    txt: "Accumulo miglia",
    icon: "check_circle",
    tooltip: "",
  },
  "0EO": {
    txt: "Compensazioni emissioni carburante",
    icon: "check_circle",
    tooltip: "",
  },
  "019": {
    txt: "Catering a bordo",
    icon: "check_circle",
    tooltip: "",
  },
  "09E": {
    txt: "Accumulo miglia",
    icon: "check_circle",
    tooltip: "",
  },
  "0FL": {
    txt: "Bagaglio da stiva 30kg",
    icon: "luggage",
    tooltip: "",
  },
  "0MZ": {
    txt: "Bagaglio in cabina 6kg",
    icon: "trolley",
    tooltip: "",
  },
  "06B": {
    txt: "Accumulo miglia",
    icon: "check_circle",
    tooltip: "",
  },
  M02: {
    txt: "Accumulo miglia",
    icon: "check_circle",
    tooltip: "",
  },
  P02: {
    txt: "2 bagagli stiva 23kg",
    icon: "luggage",
    tooltip: "",
  },
  M06: {
    txt: "Accumulo miglia",
    icon: "check_circle",
    tooltip: "",
  },
  M07: {
    txt: "Accumulo miglia",
    icon: "check_circle",
    tooltip: "",
  },
  CBY: {
    txt: "Bagaglio a mano 8kg",
    icon: "trolley",
    tooltip: "",
  },
  "06M": {
    txt: "Accumulo miglia",
    icon: "check_circle",
    tooltip: "",
  },
};
